import React from "react";
import SideBar from "../../components/SideBar";

function report() {
  return (
    <>
      <SideBar />
      <div className="MainContainer">Report</div>
    </>
  );
}

export default report;
